(function () {
    'use strict';

    'use strict';
angular.module('ngKomondorAccess', [// jshint ignore:line
'komondor-access']);
angular.module('komondor-access', ['ngKomondorResourceView', 'ng-komondor-access.templates']);
'use strict';
angular.module('komondor-access').config(["kdGateProvider", function (kdGateProvider) {
    kdGateProvider.before(function (user, ability) {
        if (user && angular.isArray(user.permissions)) {
            if (user.permissions.indexOf('super-admin') > -1) {
                return true;
            }
            if (user.permissions.indexOf(ability) > -1) {
                return true;
            }
        }
    });
}]).config(["kdGateProvider", function (kdGateProvider) {
    kdGateProvider.define('guest', function (user) {
        return !Boolean(user);
    });
    kdGateProvider.define('auth', function (user) {
        return Boolean(user);
    });
}]);
'use strict';
angular.module('komondor-access').controller('ChangePassword', ["DS", "$http", "$uibModalInstance", function (DS, $http, $uibModalInstance) {
    this.data = {};
    this.endpoint = DS.defaults.basePath + 'auth/change-password';
    this.submit = function () {
        $http.post(this.endpoint, this.data).then($uibModalInstance.close);
    }.bind(this);
}]);
'use strict';
angular.module('komondor-access').factory('changePassword', ["$uibModal", function ($uibModal) {
    return function changePassword() {
        return $uibModal.open({
            templateUrl: 'ng-komondor-access/change-password/change-password.html',
            controller: 'ChangePassword',
            controllerAs: '$ctrl'
        });
    };
}])    /**
 * Backwards compatibility
 *
 * @deprecated
 */.factory('CurrentUserModal', ["$log", "changePassword", function ($log, changePassword) {
    $log.warn('[CurrentUserModal] is deprecated, please use [changePassword] instead.');
    return changePassword;
}]);
'use strict';
angular.module('komondor-access').config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('guest.create-password', {
        url: '/create-password/:token?email',
        templateUrl: 'ng-komondor-access/createPassword/createPasswordPage.html',
        controller: ["$stateParams", function controller($stateParams) {
            this.email = $stateParams.email;
        }],
        controllerAs: 'reset'
    });
    $stateProvider.state('guest.create-password-success', {
        url: '/create-password-success',
        templateUrl: 'ng-komondor-access/createPassword/createPasswordSuccessPage.html'
    });
}]);
'use strict';
angular.module('komondor-access').directive('createPasswordForm', function () {
    return {
        restrict: 'E',
        scope: {},
        bindings: {},
        controller: 'CreatePasswordFormCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'ng-komondor-access/createPassword/createPasswordForm.html'
    };
}).controller('CreatePasswordFormCtrl', ["DS", "$http", "$stateParams", "$state", function (DS, $http, $stateParams, $state) {
    this.url = DS.defaults.basePath + 'password/reset';
    this.error = null;
    this.user = {
        token: $stateParams.token,
        email: $stateParams.email
    };
    this.submit = function () {
        $http.post(this.url, this.user).then(this.onGoodResponse, this.onBadResponse.bind(this));
    };
    this.onGoodResponse = function () {
        $state.go('guest.create-password-success');
    };
    this.onBadResponse = function (response) {
        if (response.status === 422) {
            if (response.data.email) {
                this.error = response.data.email;
            }
            return;
        }
        if (response.status === 500) {
            this.error = 'Something went wrong, please try again later.';
            return;
        }
        this.error = response.data;
    };
}]);
'use strict';
angular.module('komondor-access').config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('guest.forgot-password', {
        url: '/forgot-password',
        templateUrl: 'ng-komondor-access/forgotPassword/forgotPasswordPage.html'
    });
    $stateProvider.state('guest.forgot-password-success', {
        url: '/forgot-password-success',
        templateUrl: 'ng-komondor-access/forgotPassword/forgotPasswordSuccessPage.html'
    });
}]);
'use strict';
angular.module('komondor-access').directive('forgotPasswordForm', function () {
    return {
        restrict: 'E',
        scope: {},
        bindings: {},
        controller: 'ForgotPasswordFormCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'ng-komondor-access/forgotPassword/forgotPasswordForm.html'
    };
}).controller('ForgotPasswordFormCtrl', ["DS", "$http", "$stateParams", "$state", "$window", "resetPasswordConfig", function (DS, $http, $stateParams, $state, $window, resetPasswordConfig) {
    this.url = DS.defaults.basePath + 'password/forgot';
    this.error = null;
    this.user = { email: '' };
    if (resetPasswordConfig.resetUrlEnabled) {
        this.user['reset_url'] = $state.href('guest.reset-password', {}, { absolute: true });
    }
    this.submit = function () {
        if (resetPasswordConfig.resetUrlEnabled) {
            $http.post(this.url, this.user).then(this.onGoodResponse, this.onBadResponse.bind(this));
        } else {
            $http.post(this.url, this.user).then(this.onGoodResponse, this.onGoodResponse.bind(this));
        }
    };
    this.goback = function ($event) {
        $event.preventDefault();
        $window.history.back();
    };
    this.onGoodResponse = function () {
        $state.go('guest.forgot-password-success');
    };
    this.onBadResponse = function (response) {
        if (response.status === 422) {
            return;
        }
        if (response.status === 500) {
            this.error = 'Something went wrong, please try again later.';
            return;
        }
        this.error = response.data;
    };
}]);
'use strict';
angular.module('komondor-access').provider('kdLogin', ["$stateProvider", function ($stateProvider) {
    var loginState = {
        name: 'guest.login',
        params: null
    };
    var afterLoginState = {
        name: 'admin.users',
        params: null
    };
    this.setLoginState = function (stateName, params) {
        loginState.name = stateName;
        loginState.params = params;
    };
    this.createLoginState = function (options) {
        options = options || {};
        options = angular.extend({
            name: 'guest.login',
            url: '/login',
            templateUrl: 'ng-komondor-access/login/loginPage.html'
        }, options);
        $stateProvider.state(options.name, {
            url: options.url,
            templateUrl: options.templateUrl,
            controller: ["$scope", "kdLogin", function controller($scope, kdLogin) {
                $scope.loginHandler = function () {
                    kdLogin.afterLoginRedirect();
                };
            }]
        });
    };
    this.setAfterLoginState = function (stateName, params) {
        afterLoginState.name = stateName;
        afterLoginState.params = params;
    };
    function KdLogin($state, $http, $window, kdAuth, DS) {
        this.loginUrl = DS.defaults.basePath + 'auth/login';
        this.logoutUrl = DS.defaults.basePath + 'auth/logout';
        this.meUrl = DS.defaults.basePath + 'auth/me';
        this.loginAsUrl = DS.defaults.basePath + 'auth/login-as';
        this.redirectState = null;
        this.redirectToLogin = function (stateOrName, params) {
            if (stateOrName) {
                this.redirectState = {
                    name: stateOrName.name || stateOrName,
                    params: params
                };
            } else {
                this.redirectState = {
                    name: $state.current.name,
                    params: $state.params
                };
            }
            $state.go(loginState.name, loginState.params);
        };
        this.login = function (data) {
            var self = this;
            return $http.post(this.loginUrl, data).then(function (response) {
                return self.onLoginSuccess(response.data);
            });
        };
        this.onLoginSuccess = function (user) {
            user = DS.inject('User', user);
            kdAuth.setUser(user);
            return user;
        };
        this.afterLoginRedirect = function () {
            var nextState = this.redirectState ? this.redirectState : afterLoginState;
            this.redirectState = null;
            return $state.go(nextState.name, nextState.params, { reload: true });
        };
        this.refresh = function () {
            var self = this;
            return $http.get(this.meUrl).then(function (response) {
                return self.onLoginSuccess(response.data);
            });
        };
        this.logout = function () {
            return $http.post(this.logoutUrl).then(function (response) {
                kdAuth.setUser(null);
                DS.clear();
                // Allow custom redirect after logout
                if (response.data && response.data.redirect) {
                    $window.location.href = response.data.redirect;
                    return;
                }
                return $state.go(loginState.name, loginState.params);
            });
        };
        this.onLogoutSuccess = function () {
            kdAuth.setUser(null);
            DS.clear();
            return $state.go(loginState.name, loginState.params);
        };
        this.loginAs = function (id) {
            var self = this;
            return $http.post(this.loginAsUrl + '/' + id).then(function (response) {
                if (response.data && response.data.id) {
                    DS.clear();
                    return self.onLoginSuccess(response.data);
                } else {
                    $window.location.reload();
                }
            });
        };
    }
    this.$get = ["$state", "$http", "$window", "kdAuth", "DS", function ($state, $http, $window, kdAuth, DS) {
        return new KdLogin($state, $http, $window, kdAuth, DS);
    }];
}]);
'use strict';
angular.module('komondor-access').directive('loginForm', function () {
    return {
        restrict: 'E',
        scope: {},
        bindToController: { onLogin: '&' },
        controller: 'LoginFormCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'ng-komondor-access/login/loginForm.html'
    };
}).controller('LoginFormCtrl', ["$scope", "kdLogin", function ($scope, kdLogin) {
    this.error = null;
    this.user = {
        username: '',
        password: '',
        remember: false
    };
    this.submit = function () {
        this.error = null;
        kdLogin.login(this.user).then(this.onSuccessResponse.bind(this)).catch(this.onBadResponse.bind(this));
    };
    this.onSuccessResponse = function (user) {
        var callback = this.onLogin();
        if (callback) {
            callback(user);
        }
    };
    this.onBadResponse = function (response) {
        if (response.status === 422) {
            return;
        }
        if (response.status === 500) {
            this.error = 'Something went wrong, please try again later.';
            return;
        }
        this.error = response.data;
    };
}]);
'use strict';
angular.module('komondor-access').factory('ActionGroup', function () {
    return function (name, model, inherited) {
        this.name = name;
        this.inherited = inherited || {};
        this.inherited.actions = this.inherited.actions || {};
        this.open = false;
        this.state = 'off';
        this.actions = [];
        if (this.name === '') {
            this.name = 'Misc';
        }
        this.addAction = function (action) {
            this.actions.push(action);
        };
        this.toggle = function () {
            this.open = !this.open;
        };
        this.toggleActions = function () {
            var state = this.getState();
            var grant = state === 'on' || state === 'mixed' ? 0 : 1;
            for (var i = 0; i < this.actions.length; i++) {
                //Don't add to model actions if already inherited.
                if (this.inherited.actions[this.actions[i].id]) {
                    continue;
                }
                model.actions[this.actions[i].id] = grant;
            }
        };
        this.groupClass = function () {
            return this.getState();
        };
        this.getState = function () {
            var off = false;
            var on = false;
            var action;
            for (var i = 0; i < this.actions.length; i++) {
                action = this.actions[i];
                if (model.actions && model.actions[action.id] || this.inherited.actions[action.id]) {
                    on = true;
                } else {
                    off = true;
                }
                if (on && off) {
                    break;
                }
            }
            if (on && off) {
                return 'mixed';
            }
            if (on) {
                return 'on';
            }
            return 'off';
        };
    };
});
'use strict';
angular.module('komondor-access').component('permissionPicker', {
    controller: 'PermissionPicker',
    templateUrl: 'ng-komondor-access/permission/permission-picker.html',
    bindings: {
        actions: '=',
        model: '=',
        inherited: '=?'
    }
});
'use strict';
angular.module('komondor-access')    /**
 * This component provides a user interface to interact with `model.actions`
 *
 * Futher support for -1 to deny access may be addded in future.
 */.controller('PermissionPicker', ["ActionGroup", function (ActionGroup) {
    /**
     * @prop {array} this.actions
     */
    /**
     * @prop {object} this.model - the user or role
     * @prop {object} this.model.actions - should be a map of (action_id => 0 | 1)
     */
    /**
     * @prop {object} this.inherit - inherited actions cannot be changed from "on"
     * @prop {object} this.inherit.actions - should be a map of (action_id => 0 | 1)
     */
    this.$onInit = function () {
        // // First bit fixes PHP encoding to empty array
        if (angular.isArray(this.model.actions) || !this.model.actions) {
            this.model.actions = {};
        }
        /**
         * @prop {array} this.actionGroups
         */
        this.actionGroups = this.groupActions(this.actions);
    };
    this.groupActions = function (actions) {
        var map = {};
        var list = [];
        angular.forEach(actions, function (action) {
            if (!map[action.group]) {
                map[action.group] = new ActionGroup(action.group, this.model, this.inherited);
                list.push(map[action.group]);
            }
            map[action.group].addAction(action);
        }.bind(this));
        return list;
    };
}]);
'use strict';
angular.module('komondor-access').config(["$stateProvider", "kdAccessProvider", function ($stateProvider, kdAccessProvider) {
    $stateProvider.state('guest.register', {
        url: '/register',
        templateUrl: function templateUrl() {
            return kdAccessProvider.registerPage.templateUrl;
        },
        controller: ["$scope", "kdLogin", function controller($scope, kdLogin) {
            $scope.registerHandler = function () {
                kdLogin.afterLoginRedirect();
            };
        }]
    });
}]);
'use strict';
angular.module('komondor-access').directive('registerForm', ["kdAccess", function (kdAccess) {
    return {
        restrict: 'E',
        scope: {},
        bindToController: { onRegister: '&' },
        controller: 'RegisterFormCtrl',
        controllerAs: '$ctrl',
        templateUrl: kdAccess.registerForm.templateUrl
    };
}]).controller('RegisterFormCtrl', ["DS", "$http", "kdLogin", "kdAccess", function (DS, $http, kdLogin, kdAccess) {
    this.url = DS.defaults.basePath + 'registration/register';
    this.error = null;
    this.user = {};
    this.kdAccess = kdAccess;
    this.submit = function () {
        this.error = null;
        $http.post(this.url, this.user).then(this.onSuccessResponse.bind(this)).catch(this.onBadResponse.bind(this));
    };
    this.onSuccessResponse = function (response) {
        var user = kdLogin.onLoginSuccess(response.data);
        var callback = this.onRegister();
        if (callback) {
            callback(user);
        }
    };
    this.onBadResponse = function (response) {
        if (response.status === 422) {
            return;
        }
        if (response.status === 500) {
            this.error = 'Something went wrong, please try again later.';
            return;
        }
        this.error = response.data;
    };
}]);
'use strict';
angular.module('komondor-access').config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('guest.reset-password', {
        url: '/reset-password/:token?email',
        templateUrl: 'ng-komondor-access/resetPassword/resetPasswordPage.html',
        controller: ["$stateParams", function controller($stateParams) {
            this.email = $stateParams.email;
        }],
        controllerAs: 'reset'
    });
    $stateProvider.state('guest.reset-password-success', {
        url: '/reset-password-success',
        templateUrl: 'ng-komondor-access/resetPassword/resetPasswordSuccessPage.html'
    });
}]);
'use strict';
angular.module('komondor-access').directive('resetPasswordForm', function () {
    return {
        restrict: 'E',
        scope: {},
        bindings: {},
        controller: 'ResetPasswordFormCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'ng-komondor-access/resetPassword/resetPasswordForm.html'
    };
}).controller('ResetPasswordFormCtrl', ["DS", "$http", "$stateParams", "$state", function (DS, $http, $stateParams, $state) {
    this.url = DS.defaults.basePath + 'password/reset';
    this.error = null;
    this.user = {
        token: $stateParams.token,
        email: $stateParams.email
    };
    this.submit = function () {
        $http.post(this.url, this.user).then(this.onGoodResponse, this.onBadResponse.bind(this));
    };
    this.onGoodResponse = function () {
        $state.go('guest.reset-password-success');
    };
    this.onBadResponse = function (response) {
        if (response.status === 422) {
            return;
        }
        if (response.status === 500) {
            this.error = 'Something went wrong, please try again later.';
            return;
        }
        this.error = response.data;
    };
}]);
'use strict';
angular.module('komondor-access').factory('actionsViewOptions', ["resourceViewOptions", "extendDeep", "listView", "editAction", "deleteAction", "deselectAction", "createAction", function (resourceViewOptions, extendDeep, listView, editAction, deleteAction, deselectAction, createAction) {
    var copy = angular.copy(resourceViewOptions);
    var deletePermissionAction = angular.copy(deleteAction);
    var customCreateAction = angular.copy(createAction);
    customCreateAction.template = '<i class="material-icon material-icon-add"></i> New action';
    deletePermissionAction.show = function (models) {
        return models.length === 1 && !models[0].deleted_at && !models[0].system;
    };
    return extendDeep(copy, {
        title: 'Actions',
        actions: [deselectAction, editAction, deleteAction],
        toolbar: [customCreateAction],
        list: {
            columns: [{
                            label: 'Name',
                            name: 'name',
                            sortable: true
                        }, {
                            label: 'Gates',
                            name: 'gates',
                            template: '<ul class="list-group"\n                                   style="margin: 0;">\n                                 <li class="list-group-item"\n                                     ng-repeat="g in ::model.gates">\n                                   {{ ::g.gate }}</li>\n                               </ul>',
                            sortable: false
                        }, {
                            label: 'Group',
                            name: 'group',
                            sortable: true
                        }, {
                            label: 'Type',
                            name: 'system',
                            template: '<span>{{ model.system ? "System" : "Folder" }}</span>',
                            sortable: true
                        }]
        },
        views: [listView]
    });
}]);
'use strict';
angular.module('komondor-access').factory('rolesViewOptions', ["resourceViewOptions", "extendDeep", "listView", "createAction", function (resourceViewOptions, extendDeep, listView, createAction) {
    var copy = angular.copy(resourceViewOptions);
    var customCreateAction = angular.copy(createAction);
    customCreateAction.template = '<i class="material-icon material-icon-add"></i> New role';
    return extendDeep(copy, {
        title: 'Roles',
        with: ['users'],
        toolbar: [customCreateAction],
        list: {
            columns: [{
                            label: 'Role name',
                            name: 'name',
                            sortable: true
                        }, {
                            label: 'Super admin',
                            name: 'super_admin',
                            template: '<span>{{model.super_admin ? "Yes": "No"}}</span>',
                            sortable: true
                        }, {
                            label: '# Users',
                            name: 'users.length',
                            sortable: false
                        }]
        },
        views: [listView]
    });
}]);
'use strict';
angular.module('komondor-access').factory('usersViewOptions', ["resourceViewOptions", "extendDeep", "$window", "$http", "notify", "DS", "listView", "kdLogin", "createAction", function (resourceViewOptions, extendDeep, $window, $http, notify, DS, listView, kdLogin, createAction) {
    var customCreateAction = angular.copy(createAction);
    customCreateAction.template = '<i class="material-icon material-icon-add"></i> New user';
    var options = extendDeep(angular.copy(resourceViewOptions), {
        title: 'Users',
        with: ['role'],
        toolbar: [customCreateAction],
        list: {
            columns: [{
                            label: 'Name',
                            name: 'name',
                            sortable: true
                        }, {
                            label: 'Email',
                            name: 'email',
                            sortable: true
                        }, {
                            label: 'Role',
                            name: 'role.name',
                            sortable: false
                        }]
        },
        views: [listView]
    });
    options.actions.push({
        buttonClass: 'btn btn-default',
        tooltip: 'Login as user',
        template: '<span>Login as user</span>',
        act: function act(models) {
            kdLogin.loginAs(models[0].id).catch(function () {
                notify.alert('Failed to login as user.');
            });
        },
        show: function show(models) {
            return models.length === 1;
        }
    });
    options.actions.push({
        buttonClass: 'btn btn-default',
        tooltip: 'Tooltip',
        template: '<span>{{ $ctrl.model.active ? "Deactivate" : "Activate" }}</span>',
        act: function act(models) {
            var user = models[0];
            var status = !user.active;
            user.DSUpdate({ active: status });
        },
        show: function show(models) {
            return models.length === 1;
        }
    });
    return options;
}]);
'use strict';
angular.module('komondor-access').controller('ActionEditCtrl', ["$scope", "$q", "model", "gates", "groups", function ($scope, $q, model, gates, groups) {
    var init = function init() {
        $scope.gates = gates;
        $scope.model = model;
        $scope.groups = groups;
    };
    $scope.saveModel = function () {
        $scope.model.DSCreate($scope.model).then($scope.$close);
    };
    $scope.gateChecked = function (g) {
        return $scope.model.hasGate(g);
    };
    $scope.toggleSelection = function (gate) {
        var actionGate = $scope.model.hasGate(gate);
        if (actionGate) {
            $scope.model.removeGate(actionGate);
        } else {
            $scope.model.addGate(gate);
        }
    };
    init();
}]);
'use strict';
angular.module('komondor-access').controller('RoleEditCtrl', ["$scope", "$q", "model", "actions", function ($scope, $q, model, actions) {
    $scope.model = model;
    $scope.actions = actions;
    $scope.saveModel = function () {
        $scope.model.DSCreate().then(function () {
            $scope.$close(model);
        });
    };
}]);
'use strict';
angular.module('komondor-access').controller('UserEditCtrl', ["$scope", "kdAccess", "model", "roles", "actions", "Role", "DS", "$http", "$state", function ($scope, kdAccess, model, roles, actions, Role, DS, $http, $state) {
    $scope.model = model;
    $scope.roles = roles;
    $scope.actions = actions;
    $scope.kdAccess = kdAccess;
    $scope.inherited = { actions: null };
    $scope.invitations = { sendEmail: false };
    $scope.roles.unshift({
        id: 0,
        name: '- Choose role -'
    });
    function init() {
        $scope.setSelectedRole($scope.model.role_id);
    }
    $scope.setSelectedRole = function (id) {
        $scope.model.role_id = id;
        $scope.selectedRole = id === 0 ? $scope.roles[0] : Role.filter({ id: id })[0];
    };
    $scope.buildInheritActions = function () {
        $scope.inherited.actions = {};
        if (model.role) {
            angular.forEach(model.role.permissions, function (action) {
                $scope.inherited.actions[action.id] = action.pivot.grant;
            });
        }
    };
    $scope.saveModel = function () {
        if ($scope.invitations.sendEmail) {
            $scope.model.password = DS.utils.guid();
        }
        var created = $scope.model.DSCreate();
        if ($scope.invitations.sendEmail) {
            created.then(function () {
                $http.post(DS.defaults.basePath + 'password/invite', {
                    email: model.email,
                    reset_url: $state.href('guest.create-password', {}, { absolute: true })
                });
                return true;
            });
        }
        created.then(function () {
            return $scope.$close(model);
        });
    };
    $scope.$on('$destroy', function () {
        delete $scope.model.password;
        delete $scope.model.password_confirmation;
    });
    $scope.$watch('model.role_id', $scope.buildInheritActions);
    init();
}]);
'use strict';
angular.module('komondor-access').config(["kdGateProvider", function (kdGateProvider) {
    kdGateProvider.define('dropdown-permissions', function () {
        return true;
    });
}]).directive('dropdownPermissions', ["$uibModal", "Action", function ($uibModal, Action) {
    controller.$inject = ["$scope"];
    function controller($scope) {
        $scope.addNewPermission = function () {
            $scope.modal = $uibModal.open({
                templateUrl: 'ng-komondor-access/action.edit.html',
                controller: ['$scope', 'Action', function ($scope, Action) {
                
                                    $scope.model = { name: '', group: '', system: 0 };
                
                                    $scope.saveModel = function () {
                                        Action.create($scope.model).then($scope.$close, $scope.$dismiss);
                                    };
                                }]
            });
        };
        $scope.$watch(function () {
            return Action.lastModified();
        }, function () {
            var defaultAction = {
                id: 0,
                system: 0,
                name: $scope.model.folder_id > 0 ? '-- Inherit --' : '-- Public --',
                group: ''
            };
            var params = { where: { system: { '==': 0 } } };
            $scope.actions = Action.filter(params);
            $scope.actions.splice(0, 0, defaultAction);
        });
    }
    return {
        restrict: 'AE',
        scope: { model: '=' },
        controller: controller,
        template: '<div form-group="action_id" kd-gate="dropdown-permissions">' + '<label for="action_id">Permission - <a href ng-click="addNewPermission()">New Action</a></label>' + '<select id="action_id" class="form-control" ng-model="model.action_id" ' + 'ng-options="action.id as action.name group by action.group for action in actions">' + '</select>' + '</div>'
    };
}]);
'use strict';
angular.module('komondor-access').provider('kdAccess', function () {
    /**
     * @deprecated
     */
    this.userFields = { templateUrl: null };
    this.registerPage = { templateUrl: 'ng-komondor-access/register/registerPage.html' };
    this.registerForm = { templateUrl: 'ng-komondor-access/register/registerForm.html' };
    this.userEditForm = { invitations: false };
    this.$get = function () {
        return this;
    };
});
'use strict';
angular.module('komondor-access').factory('resetPasswordConfig', function resetPasswordConfig() {
    return { resetUrlEnabled: true };
});
'use strict';
angular.module('komondor-access').run(["Action", function (Action) {
}])    // jshint ignore:line
.factory('Action', ["DS", function (DS) {
    return DS.defineResource({
        name: 'Action',
        endpoint: 'actions',
        upsert: true,
        methods: {
            hasGate: function hasGate(gateName) {
                if (!this.gates) {
                    return null;
                }
                return this.gates.find(function (actionGate) {
                    return actionGate.gate === gateName;
                });
            },
            addGate: function addGate(gateName) {
                if (this.hasGate(gateName)) {
                    return;
                }
                this.gates = this.gates || [];
                this.gates.push({ gate: gateName });
            },
            removeGate: function removeGate(gate) {
                var index = this.gates.indexOf(gate);
                this.gates.splice(index, 1);
            }
        },
        relations: {
            hasMany: {
                Permission: {
                    foreignKey: 'role_id',
                    localField: 'permissions'
                }
            }
        }
    });
}]);
'use strict';
angular.module('komondor-access').run(["Permission", function (Permission) {
}])    // jshint ignore:line
.factory('Permission', ["DS", function (DS) {
    return DS.defineResource({
        name: 'Permission',
        endpoint: 'permissions',
        upsert: true,
        relations: {
            belongsTo: {
                Role: {
                    localKey: 'role_id',
                    localField: 'role'
                },
                Action: {
                    localKey: 'action_id',
                    localField: 'action'
                }
            }
        }
    });
}]);
'use strict';
angular.module('komondor-access').run(["Role", function (Role) {
}])    // jshint ignore:line
.factory('Role', ["DS", function (DS) {
    return DS.defineResource({
        name: 'Role',
        endpoint: 'roles',
        upsert: true,
        relations: {
            hasMany: {
                User: {
                    foreignKey: 'role_id',
                    localField: 'users'
                }
            }
        }
    });
}]);
'use strict';
angular.module('komondor-access').run(["User", function (User) {
}])    // jshint ignore:line
.factory('User', ["DS", function (DS) {
    return DS.defineResource({
        name: 'User',
        endpoint: 'users',
        upsert: true,
        beforeCreateInstance: function beforeCreateInstance(resource, data) {
            data.role_id = 0;
            return data;
        },
        relations: {
            belongsTo: {
                Role: {
                    localKey: 'role_id',
                    localField: 'role'
                }
            }
        }
    });
}]);
'use strict';
angular.module('ngKomondor').provider('actionsStateOptions', function () {
    this.config = {
        title: 'Actions',
        url: 'actions',
        model: 'Action',
        viewOptions: 'actionsViewOptions',
        move: false,
        delete: true,
        deleteCheckDependencies: true,
        edit: {
            controller: 'ActionEditCtrl',
            templateUrl: 'ng-komondor-access/action.edit.html',
            resolve: {
                gates: ['$http', function ($http) {
                                    return $http.get('api/actions/gates').then(function (response) {
                                        return response.data;
                                    }, function () {
                                        return [];
                                    });
                                }],
                groups: ['Action', function (Action) {
                                    return Action.findAll().then(function (data) {
                                        return data.reduce(function (arr, action) {
                                            if (arr.indexOf(action.group) < 0) {
                                                arr.push(action.group);
                                            }
                                            return arr;
                                        }, []);
                                    });
                                }]
            }
        }
    };
    this.$get = function () {
        return this.config;
    };
});
angular.module('komondor-access').config(["resourceStateProvider", "actionsStateOptionsProvider", function (resourceStateProvider, actionsStateOptionsProvider) {
    resourceStateProvider.state('admin.actions', actionsStateOptionsProvider.$get());
}]);
'use strict';
angular.module('ngKomondor').provider('rolesStateOptions', function () {
    this.config = {
        title: 'Roles',
        url: 'roles',
        model: 'Role',
        viewOptions: 'rolesViewOptions',
        edit: {
            controller: 'RoleEditCtrl',
            templateUrl: 'ng-komondor-access/role.edit.html',
            resolve: {
                model: ['Role', 'modalState', '$q', function (Role, modalState, $q) {
                                    var paramId = parseInt(modalState.stateParams.id);
                
                                    if (!paramId) {
                                        modalState.model = Role.createInstance();
                                        return modalState.model;
                                    }
                
                                    return Role.find(paramId, {
                                        params: {
                                            with: 'actions'
                                        }
                                    }).then(function (model) {
                                        modalState.model = model;
                                        return model;
                                    }, function (reason) {
                                        return $q.reject('Role not found with id [' + paramId + '].', reason);
                                    });
                                }],
                actions: ['Action', function (Action) {
                                    return Action.findAll({
                                        sort: [['group', 'ASC']]
                                    });
                                }]
            }
        }
    };
    this.$get = function () {
        return this.config;
    };
});
angular.module('komondor-access').config(["resourceStateProvider", "rolesStateOptionsProvider", function (resourceStateProvider, rolesStateOptionsProvider) {
    resourceStateProvider.state('admin.roles', rolesStateOptionsProvider.$get());
}]);
'use strict';
angular.module('ngKomondor').provider('usersStateOptions', function () {
    this.config = {
        title: 'Users',
        url: 'users',
        model: 'User',
        viewOptions: 'usersViewOptions',
        edit: {
            controller: 'UserEditCtrl',
            templateUrl: 'ng-komondor-access/user.edit.html',
            resolve: {
                model: ['User', 'modalState', '$q', function (User, modalState, $q) {
                                    var paramId = parseInt(modalState.stateParams.id);
                
                                    if (!paramId) {
                                        modalState.model = User.createInstance();
                                        return modalState.model;
                                    }
                
                                    return User.find(paramId, {
                                        params: {
                                            with: 'actions'
                                        }
                                    }).then(function (model) {
                                        modalState.model = model;
                                        return model;
                                    }, function (reason) {
                                        return $q.reject('User not found with id [' + paramId + '].', reason);
                                    });
                                }],
                actions: ['Action', function (Action) {
                                    return Action.findAll({
                                        sort: [['group', 'ASC']]
                                    });
                                }],
                roles: ['Role', function (Role) {
                                    return Role.findAll({
                                        with: 'permissions',
                                        limit: 10000
                                    });
                                }]
            }
        }
    };
    this.$get = function () {
        return this.config;
    };
});
angular.module('komondor-access').config(["resourceStateProvider", "usersStateOptionsProvider", function (resourceStateProvider, usersStateOptionsProvider) {
    resourceStateProvider.state('admin.users', usersStateOptionsProvider.$get());
}]);
'use strict';
angular.module('ng-komondor-access.templates', []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("ng-komondor-access/action.edit.html", "<form ng-submit=\"saveModel()\"><div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">{{ ::model.id ? \'Edit\' : \'New\' ;}} action</h1></div><div class=\"modal-body\"><div form-group=\"name\" class=\"form-group\"><label class=\"control-label\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"model.name\"></div><div form-group=\"group\" class=\"form-group\" style=\"position: relative;\"><label class=\"control-label\">Group</label><input type=\"text\" class=\"form-control\" name=\"group\" ng-model=\"model.group\" uib-typeahead=\"group for group in groups | filter:$viewValue | limitTo:4\"></div><div ng-if=\"gates.length > 0\"><checkbox-input name=\"type\" label=\"\'System\'\" ng-model=\"model.system\" true-value=\"1\" false-value=\"0\"></checkbox-input><div class=\"permission\" ng-if=\"model.system\"><label>Gates</label><div ng-repeat=\"g in gates\"><div class=\"checkbox-input\"><input id=\"checkbox-input-{{$id}}\" type=\"checkbox\" ng-checked=\"gateChecked(g)\" ng-click=\"toggleSelection(g)\"><label for=\"checkbox-input-{{$id}}\">{{ g }}</label></div></div></div></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"$dismiss()\">Cancel</button></div><div class=\"col-xs-6\"><button type=\"submit\" id=\"action-edit-save\" class=\"btn btn-primary btn-block\" loading-disabled>Save</button></div></div></div></form>");
  $templateCache.put("ng-komondor-access/role.edit.html", "<form ng-submit=\"saveModel()\"><div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">{{ ::model.id ? \'Edit\' : \'New\' }} role</h1></div><div class=\"modal-body\"><div form-group=\"name\" class=\"form-group\"><label class=\"control-label\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"model.name\"></div><div form-group=\"super_admin\" kd-gate=\"super-admin\"><label>Super Admin <input id=\"type\" type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"model.super_admin\"></label></div><div class=\"form-group\"><label class=\"control-label\">Permissions</label><permission-picker actions=\"actions\" model=\"model\"></permission-picker></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"$dismiss()\">Cancel</button></div><div class=\"col-xs-6\"><button type=\"submit\" id=\"role-edit-save\" class=\"btn btn-primary btn-block\" loading-disabled>Save</button></div></div></div></form>");
  $templateCache.put("ng-komondor-access/user.change.password.html", "<form ng-submit=\"saveModel()\"><div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">Change password</h1></div><div class=\"modal-body\"><div form-group=\"old_password\"><label class=\"control-label\" for=\"old_password\">Old Password</label><input class=\"form-control\" ng-model=\"model.old_password\" type=\"password\" id=\"old_password\"></div><div form-group=\"password\"><label class=\"control-label\" for=\"password\">Password</label><input class=\"form-control\" ng-model=\"model.password\" type=\"password\" id=\"password\"></div><div form-group=\"password_confirmation\"><label class=\"control-label\" for=\"password_confirmation\">Password Confirm</label><input class=\"form-control\" ng-model=\"model.password_confirmation\" type=\"password\" id=\"password_confirmation\"></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"$dismiss()\">Cancel</button></div><div class=\"col-xs-6\"><button type=\"submit\" class=\"btn btn-primary btn-block\" loading-disabled>Save</button></div></div></div></form>");
  $templateCache.put("ng-komondor-access/user.edit.html", "<form ng-submit=\"saveModel()\"><div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">{{ ::model.id ? \'Edit\' : \'New\' }} user</h1></div><div class=\"modal-body\"><div form-group=\"name\"><label class=\"control-label\" for=\"name\">Name</label><input type=\"text\" class=\"form-control\" ng-model=\"model.name\" id=\"name\"></div><div form-group=\"email\"><label class=\"control-label\" for=\"email\">Email</label><input type=\"text\" class=\"form-control\" id=\"email\" ng-model=\"model.email\" autocomplete=\"off\"></div><div form-group=\"phone\" id=\"phone-group\"><label class=\"control-label\" for=\"email\">Phone</label><input type=\"text\" class=\"form-control\" id=\"phone\" ng-model=\"model.phone\" autocomplete=\"off\"></div><div form-group=\"job_title\" id=\"title-group\"><label class=\"control-label\" for=\"email\">Job title</label><input type=\"text\" class=\"form-control\" id=\"job_title\" ng-model=\"model.job_title\" autocomplete=\"off\"></div><div form-group=\"job_dep\" id=\"dep-group\"><label class=\"control-label\" for=\"email\">Department</label><input type=\"text\" class=\"form-control\" id=\"job_dep\" ng-model=\"model.job_dep\" autocomplete=\"off\"></div><div form-group=\"password\"><label class=\"control-label\" for=\"password\">Password</label><input type=\"password\" class=\"form-control\" ng-model=\"model.password\" autocomplete=\"off\" id=\"password\" ng-disabled=\"kdAccess.userEditForm.invitations\"></div><div form-group=\"email-password\" ng-if=\"kdAccess.userEditForm.invitations\"><label class=\"control-label\" for=\"email-password\">Email password reset link to user</label><checkbox-input class=\"btn btn-block\" ng-model=\"invitations.sendEmail\" id=\"email-password\"></div><div ng-include=\"kdAccess.userFields.templateUrl\"></div><div form-group=\"role_id\"><label>Role</label><div uib-dropdown keyboard-nav=\"true\" class=\"dropdown\"><button uib-dropdown-toggle class=\"btn btn-white btn-block\"><span>{{ selectedRole.name }}</span><span class=\"caret\"></span></button><ul uib-dropdown-menu class=\"dropdown-menu dropdown-menu-fullwidth\"><li class=\"dropdown-item\" ng-repeat=\"(key, value) in roles\"><button class=\"btn btn-white btn-block\" ng-click=\"$event.preventDefault(); setSelectedRole(value.id)\">{{ value.name }}</button></li></ul></div></div><div class=\"form-group\"><label class=\"control-label\">Permissions</label><div ng-show=\"model.role.super_admin\">Super Admin</div><permission-picker actions=\"actions\" model=\"model\" inherited=\"inherited\" ng-hide=\"model.role.super_admin\"></permission-picker></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"$dismiss()\">Cancel</button></div><div class=\"col-xs-6\"><button type=\"submit\" id=\"user-edit-save\" class=\"btn btn-primary btn-block\" loading-disabled>Save</button></div></div></div></form>");
  $templateCache.put("ng-komondor-access/change-password/change-password.html", "<form ng-submit=\"$ctrl.submit()\"><div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">Change password</h1></div><div class=\"modal-body\"><div form-group=\"old_password\"><label class=\"control-label\" for=\"old_password\">Current password</label><input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.data.old_password\" autocomplete=\"off\"></div><div form-group=\"password\"><label class=\"control-label\" for=\"password\">New password</label><input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.data.password\" autocomplete=\"off\"></div><div form-group=\"password_confirmation\"><label class=\"control-label\" for=\"password_confirmation\">Confirm new password</label><input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.data.password_confirmation\" autocomplete=\"off\"></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"$dismiss()\">Cancel</button></div><div class=\"col-xs-6\"><button type=\"submit\" class=\"btn btn-primary btn-block\" loading-disabled>Set new password</button></div></div></div></form>");
  $templateCache.put("ng-komondor-access/permission/permission-picker.html", "<div class=\"permission\"><div class=\"permission-group\" ng-repeat=\"group in $ctrl.actionGroups\" ng-class=\"{open: group.open}\"><div class=\"permission-group-heading\" ng-click=\"group.toggleActions()\" ng-class=\"group.groupClass()\"><a ng-click=\"group.toggle(); $event.stopPropagation()\"><i class=\"material-icon material-icon-keyboard-arrow-up\" ng-show=\"group.open\"></i><i class=\"material-icon material-icon-keyboard-arrow-down\" ng-show=\"!group.open\"></i></a><span>{{ group.name }}</span></div><div class=\"permission-group-action\" ng-repeat=\"action in group.actions\"><input type=\"checkbox\" id=\"action-{{ action.id }}\" ng-model=\"$ctrl.model.actions[action.id]\" ng-true-value=\"1\" ng-false-value=\"0\"><label class=\"label-enabled\" for=\"action-{{ action.id }}\" ng-show=\"!$ctrl.inherited.actions[action.id]\"><span>{{ action.name }}</span></label><label class=\"label-disabled\" ng-show=\"$ctrl.inherited.actions[action.id]\">{{ action.name }}<span class=\"material-icon material-icon-check\"></span></label></div></div></div>");
  $templateCache.put("ng-komondor-access/login/loginForm.html", "<form method=\"\" ng-submit=\"$ctrl.submit()\"><div form-group=\"username\"><label for=\"username\">E-Mail Address</label><input class=\"form-control\" type=\"text\" name=\"username\" id=\"username\" ng-model=\"$ctrl.user.username\"></div><div form-group=\"password\"><label for=\"password\">Password</label><input class=\"form-control\" type=\"password\" name=\"password\" id=\"password\" ng-model=\"$ctrl.user.password\"></div><div form-group=\"remember\"><input type=\"checkbox\" name=\"remember\" id=\"remember\" ng-model=\"$ctrl.user.remember\"><label for=\"remember\">Remember Me</label></div><div class=\"form-group form-actions\"><button type=\"submit\" class=\"btn btn-primary\">Login</button><a class=\"btn btn-link\" ui-sref=\"guest.forgot-password\">Forgot your password?</a></div><div class=\"form-group\" ng-show=\"$ctrl.error\"><div class=\"alert alert-danger\" role=\"alert\">{{ $ctrl.error }}</div></div></form>");
  $templateCache.put("ng-komondor-access/login/loginPage.html", "<div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Login</div><div class=\"panel-body\"><login-form on-login=\"loginHandler\"></login-form></div></div></div></div>");
  $templateCache.put("ng-komondor-access/register/registerForm.html", "<form method=\"\" ng-submit=\"$ctrl.submit()\"><div form-group=\"name\"><label for=\"name\">Name</label><input class=\"form-control\" type=\"text\" name=\"name\" id=\"name\" ng-model=\"$ctrl.user.name\"></div><div form-group=\"username\"><label for=\"username\">E-Mail Address</label><input class=\"form-control\" type=\"text\" name=\"username\" id=\"username\" ng-model=\"$ctrl.user.username\"></div><div form-group=\"password\"><label for=\"password\">Password</label><input class=\"form-control\" type=\"password\" name=\"password\" id=\"password\" ng-model=\"$ctrl.user.password\"></div><div form-group=\"password_confirmation\"><label for=\"password_confirmation\">Password Confirm</label><input class=\"form-control\" type=\"password\" name=\"password_confirmation\" id=\"password_confirmation\" ng-model=\"$ctrl.user.password_confirmation\"></div><div class=\"form-group form-actions\"><button type=\"submit\" class=\"btn btn-primary\">Register</button><a class=\"btn btn-link\" ui-sref=\"guest.login\">Already have an account?</a></div><div class=\"form-group\" ng-show=\"$ctrl.error\"><div class=\"alert alert-danger\" role=\"alert\">{{ $ctrl.error }}</div></div></form>");
  $templateCache.put("ng-komondor-access/register/registerPage.html", "<div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Register</div><div class=\"panel-body\"><register-form on-register=\"registerHandler\"></register-form></div></div></div></div>");
  $templateCache.put("ng-komondor-access/resetPassword/resetPasswordForm.html", "<form method=\"\" ng-submit=\"$ctrl.submit()\"><div form-group=\"password\"><label for=\"password\">Password</label><input class=\"form-control\" type=\"password\" name=\"password\" id=\"password\" ng-model=\"$ctrl.user.password\"></div><div form-group=\"password_confirmation\"><label for=\"password_confirmation\">Password Confirm</label><input class=\"form-control\" type=\"password\" name=\"password_confirmation\" id=\"password_confirmation\" ng-model=\"$ctrl.user.password_confirmation\"></div><div class=\"form-actions\"><button type=\"submit\" class=\"btn btn-primary\">Reset Password</button></div><div class=\"form-group error\">{{ $ctrl.error }}</div></form>");
  $templateCache.put("ng-komondor-access/resetPassword/resetPasswordPage.html", "<div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Password Reset</div><div class=\"panel-body\"><p>Hello<i>{{reset.email}}</i>, please use this form to reset your password.</p><reset-password-form></reset-password-form></div></div></div></div>");
  $templateCache.put("ng-komondor-access/resetPassword/resetPasswordSuccessPage.html", "<div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Password Reset!</div><div class=\"panel-body\"><p>Your password has been reset!</p><a class=\"btn btn-default\" ui-sref=\"guest.login\">Login</a></div></div></div></div>");
  $templateCache.put("ng-komondor-access/forgotPassword/forgotPasswordForm.html", "<form method=\"\" ng-submit=\"$ctrl.submit()\"><div form-group=\"email\"><label for=\"email\">E-mail address</label><input class=\"form-control\" type=\"text\" name=\"email\" id=\"email\" ng-model=\"$ctrl.user.email\"></div><div class=\"form-actions row\"><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"$ctrl.goback($event)\">Just remembered</button></div><div class=\"col-xs-6\"><button type=\"submit\" class=\"btn btn-primary btn-block\">Reset my password</button></div></div><div class=\"form-group error\">{{ $ctrl.error }}</div></form>");
  $templateCache.put("ng-komondor-access/forgotPassword/forgotPasswordPage.html", "<div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><div class=\"panel panel-default\"><h1 class=\"panel-heading\">Reset password</h1><p class=\"text-center\">Enter your e-mail and we will send you further instructions.</p><div class=\"panel-body\"><forgot-password-form></forgot-password-form></div></div></div></div>");
  $templateCache.put("ng-komondor-access/forgotPassword/forgotPasswordSuccessPage.html", "<div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><div class=\"panel panel-default\"><h1 class=\"panel-heading\">Reset password</h1><div class=\"panel-body text-center\"><p>We are handling your request - check your email and follow the steps.</p></div><div class=\"panel-btn-container\" style=\"display: none\"><button class=\"panel-btn\"><a href=\"/login\">Back to Login</a></button></div></div></div></div>");
  $templateCache.put("ng-komondor-access/createPassword/createPasswordForm.html", "<form method=\"\" ng-submit=\"$ctrl.submit()\"><div form-group=\"password\"><label for=\"password\">Password</label><input class=\"form-control\" type=\"password\" name=\"password\" id=\"password\" ng-model=\"$ctrl.user.password\"></div><div form-group=\"password_confirmation\"><label for=\"password_confirmation\">Password Confirm</label><input class=\"form-control\" type=\"password\" name=\"password_confirmation\" id=\"password_confirmation\" ng-model=\"$ctrl.user.password_confirmation\"></div><div class=\"form-actions\"><button type=\"submit\" class=\"btn btn-primary\">Submit</button></div><div class=\"form-group error\">{{ $ctrl.error }}</div></form>");
  $templateCache.put("ng-komondor-access/createPassword/createPasswordPage.html", "<div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Complete Registration</div><div class=\"panel-body\"><p>Hello<strong ng-if=\"reset.email\">&nbsp;{{reset.email}}</strong>, please use this form to enter your password.</p><create-password-form></create-password-form></div></div></div></div>");
  $templateCache.put("ng-komondor-access/createPassword/createPasswordSuccessPage.html", "<div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Registration complete!</div><div class=\"panel-body\"><p>Your account has been created!</p><a class=\"btn btn-default\" ui-sref=\"guest.login\">Login</a></div></div></div></div>");
}]);
})();

//# sourceMappingURL=ng-komondor-access.js.map
